.deselectionModal {
  display: flex;
  flex-direction: column;
  width: 680px;
  background-color: var(--sparky-brand-white);
}

.modalHeader {
  display: flex;
  justify-content: flex-end;
  padding: 12px 12px var(--spacing-08);
}

.modalBody {
  padding: 0 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 12px;
}

.buttonRow {
  display: flex;
  column-gap: 12px;
  padding-top: 12px;
}

.cancelButton {
  color: var(--button-danger-text-02);
}
